import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';

class RestoreTreeNodeRequest extends BaseServiceRequest {
    constructor(nodeIds) {
        super();
        super.addRequestUri("restoretreenodes.pb");
        super.addRequestParameter("nodeIds", nodeIds);
    }

    getMethod() {
        return HttpMethodType.PUT;
    }

    getSubSystem() {
        return SubSystemType.LIST;
    }

    getMessageName() {
        return "Response";
    }
}
export default RestoreTreeNodeRequest;